/* istanbul ignore file */

import { useEffect, useState } from 'react';
import { getProductIdFromProductCode } from '@noths/polaris-client-utils';

import { Product, ProductFromResponse } from '../../types/Product';
import { RichRelevanceProduct } from '../../types/RecentlyViewed';
import { fetchAdditionalProductData } from '../../utils/fetchAdditionalProductData';

const decorateProductsWithRRData = (
  products: ProductFromResponse[],
  placementItems: RichRelevanceProduct[],
): Product[] =>
  products.map((product) => {
    const placementItem = placementItems.find(
      ({ id }) => getProductIdFromProductCode(product.code) === Number(id),
    );

    return {
      ...product,
      linkURL: placementItem?.linkURL ?? '',
    };
  });

export const useRichRelevanceData = (items: RichRelevanceProduct[]) => {
  const [products, setProducts] = useState([] as ProductFromResponse[]);

  useEffect(() => {
    const getRichRelevanceData = async () => {
      if (items && items.length > 0) {
        try {
          const products: ProductFromResponse[] =
            (await fetchAdditionalProductData(items)) || ([] as ProductFromResponse[]);

          setProducts(products);
        } catch (error) {
          console.error(error);
        }
      }
    };

    getRichRelevanceData();
  }, [items]);

  return decorateProductsWithRRData(products, items);
};
